module.exports = __webpack_public_path__ + "static/project_reactbricks_logo-42fa4b32c5c9ab6f6af756f33d21901c.svg";